/** Waits, then runs; the returned call cancels a run that has not happened yet. */
export type RealtimeHandoverTimer = (run: () => void, delayMs: number) => () => void;

export const scheduleWithTimeout: RealtimeHandoverTimer = (run, delayMs) => {
  const id = setTimeout(run, delayMs);
  return () => clearTimeout(id);
};
